import { Signal as H, DisposalScope as L, withScope as N, Value as _, prop as K, ElementPosition as ee, signal as q, KeyedPosition as le, pushScope as oe, popScope as ce } from "@tempots/core";
class He extends Error {
  constructor(R) {
    super(`Provider not found: ${R.description}`);
  }
}
function ae(T) {
  this.tracked === null && (this.tracked = []), this.tracked.push(T);
}
function ie(T) {
  this.disposeCallbacks === null && (this.disposeCallbacks = []), this.disposeCallbacks.push(T);
}
function Ne(T) {
  const { create: R } = T, ue = (e) => {
    const t = R((r) => {
      const s = r.makeChildText(e);
      return (o) => s.clear(o);
    });
    return t.kind = "static-text", t.text = String(e), t;
  }, te = (e) => e ?? "", fe = (e) => {
    const t = R((r) => {
      const s = r.makeChildText(te(e.value)), o = e.onChange((n) => s.setText(te(n)));
      return (n) => {
        o(), s.clear(n);
      };
    });
    return t.kind = "dynamic-text", t.source = e, t.transform = String, t;
  }, pe = (e, t) => {
    const r = R((s) => {
      const o = s.makeChildText(t(e.value)), n = e.onChange((i) => o.setText(t(i)));
      return (i) => {
        n(), o.clear(i);
      };
    });
    return r.kind = "dynamic-text", r.source = e, r.transform = t, r;
  }, W = (e, t, r) => H.is(e) ? t(e) : r(e), h = (e) => {
    if (e == null)
      return w;
    if (Array.isArray(e))
      return U(...e.map(h));
    if (typeof e == "string" || typeof e == "number" || typeof e == "boolean")
      return ue(e);
    if (H.is(e))
      return fe(e);
    if (typeof e == "object" && "render" in e && "type" in e)
      return e;
    throw new Error(`Unknown type: '${typeof e}' for child: ${e}`);
  }, ne = (e, t, r) => {
    const s = e.makeMarker();
    let o = () => {
    }, n = null;
    const i = t.on(
      (a) => {
        n?.dispose(), o(!0), n = new L(), o = N(
          n,
          () => h(r(a)).render(s)
        );
      },
      { noAutoDispose: !0 }
    );
    return (a) => {
      n?.dispose(), o(a), i(), s.clear(a);
    };
  }, w = R(() => () => {
  });
  w.kind = "empty";
  const U = (...e) => {
    const t = e.map(h), r = R((s) => {
      const o = t.map((n) => n.render(s));
      return (n) => {
        o.forEach((i) => i(n));
      };
    });
    return r.kind = "fragment", r.children = t, r;
  }, J = (e, t, r) => W(
    e,
    (s) => R(
      (o) => ne(
        o,
        s,
        (n) => n ? t() : r?.()
      )
    ),
    (s) => {
      if (s) {
        const o = t();
        return o != null ? h(o) : w;
      }
      return h(r?.());
    }
  ), de = (e, t, r) => J(
    _.map(e, (s) => !s),
    t,
    r
  ), Q = (e, t, r) => {
    if (r != null)
      return Q(e, (s) => {
        const o = new ee(
          s.index,
          s.total.map((n) => n - 1)
        );
        return U(
          h(t(s)),
          J(
            s.isLast,
            () => w,
            () => r(o)
          )
        );
      });
    if (H.is(e))
      return R((s) => {
        const o = e.derive(), n = s.makeMarker(), i = [], a = [], u = T.templateEngine;
        let l = null, p = !u;
        return o.on((C) => {
          const S = i.splice(C), d = a.splice(C);
          for (const m of d)
            m.dispose();
          for (const m of S)
            m(!0);
          for (let m = i.length; m < C; m++) {
            const M = new ee(m, o), z = new L();
            a.push(z), i.push(
              N(z, () => {
                const E = h(t(M));
                if (p) return E.render(n);
                if (l === null) {
                  const B = u.fingerprint(E);
                  if (B === null)
                    return p = !0, E.render(n);
                  const j = u.build(E, n);
                  return j ? (l = { compiled: j, fp: B, verified: !1 }, u.cloneAndHydrate(
                    j,
                    n,
                    u.extractSlots(E)
                  ).clear) : (p = !0, E.render(n));
                }
                if (!l.verified) {
                  if (u.fingerprint(E) !== l.fp)
                    return p = !0, l = null, E.render(n);
                  l.verified = !0;
                }
                return u.cloneAndHydrate(
                  l.compiled,
                  n,
                  u.extractSlots(E)
                ).clear;
              })
            );
          }
        }), (C) => {
          for (const S of a)
            S.dispose();
          a.length = 0, o.dispose();
          for (const S of i)
            S(C);
          i.length = 0, n.clear(C);
        };
      });
    {
      const s = q(e);
      return U(
        ...Array.from({ length: e }, (o, n) => n).map((o) => {
          const n = new ee(o, s);
          return h(t(n));
        })
      );
    }
  }, he = (e, t, r) => {
    const s = _.map(e, (n) => n.length), o = _.toSignal(e);
    return Q(
      s,
      (n) => {
        const i = o.map((a) => a[n.index]);
        return h(t(i, n));
      },
      r
    );
  }, ge = (e) => {
    const t = e.length;
    if (t === 0) return [];
    const r = [], s = [], o = new Array(t).fill(-1);
    for (let a = 0; a < t; a++) {
      const u = e[a];
      let l = 0, p = r.length;
      for (; l < p; ) {
        const C = l + p >>> 1;
        r[C] < u ? l = C + 1 : p = C;
      }
      r[l] = u, s[l] = a, o[a] = l > 0 ? s[l - 1] : -1;
    }
    const n = new Array(r.length);
    let i = s[r.length - 1];
    for (let a = r.length - 1; a >= 0; a--)
      n[a] = i, i = o[i];
    return n;
  }, ke = (e, t, r, s) => W(
    e,
    (o) => R((n) => {
      const i = n.makeMarker(), a = K(0), u = (c, g) => {
        if (g !== null)
          for (let v = 0; v < g.length; v++) g[v]();
        if (c !== null)
          for (let v = 0; v < c.length; v++) c[v].dispose();
      }, l = [], p = /* @__PURE__ */ new Map(), C = r.length >= 2 || s != null, S = T.templateEngine;
      let d = null, m = !S;
      const M = (c, g) => {
        if (m)
          return { clear: c.render(g), startCtx: null };
        if (d === null) {
          const O = S.fingerprint(c);
          if (O === null)
            return m = !0, { clear: c.render(g), startCtx: null };
          const b = S.build(c, g);
          if (!b)
            return m = !0, { clear: c.render(g), startCtx: null };
          d = { compiled: b, fp: O, verified: !1 };
          const x = S.cloneAndHydrate(
            b,
            g,
            S.extractSlots(c)
          );
          return { clear: x.clear, startCtx: x.startCtx };
        }
        if (!d.verified) {
          if (S.fingerprint(c) !== d.fp)
            return m = !0, d = null, { clear: c.render(g), startCtx: null };
          d.verified = !0;
        }
        const v = S.cloneAndHydrate(
          d.compiled,
          g,
          S.extractSlots(c)
        );
        return { clear: v.clear, startCtx: v.startCtx };
      }, z = (c, g, v) => {
        const O = t(c), b = K(c), x = C ? new le(g, a) : null, G = !m && d !== null && d.verified;
        let P;
        G || (P = n.makeMarker(), n.moveRangeBefore(P, P, v));
        const I = n.makeMarker();
        n.moveRangeBefore(I, I, v);
        const A = {
          key: O,
          valueProp: b,
          position: x,
          tracked: null,
          disposeCallbacks: null,
          clear: void 0,
          startRef: P,
          endRef: I,
          track: ae,
          onDispose: ie
        };
        oe(A);
        try {
          const Z = h(r(b, x)), F = M(Z, I);
          A.clear = F.clear, F.startCtx && (P && P.clear(!0), A.startRef = F.startCtx);
        } finally {
          ce();
        }
        return A;
      }, E = (c, g = !0) => {
        u(c.tracked, c.disposeCallbacks), c.clear(g), c.startRef.clear(g), c.endRef.clear(g), c.position?.dispose(), c.valueProp.dispose(), c.sepClear && (u(
          c.sepTracked ?? null,
          c.sepDisposeCallbacks ?? null
        ), c.sepClear(g), c.sepStartRef?.clear(g));
      }, B = () => {
        if (l.length !== 0) {
          n.removeAllBefore(i);
          for (let c = 0; c < l.length; c++)
            E(l[c], !1);
          l.length = 0, p.clear();
        }
      }, j = (c, g) => {
        if (!s) return;
        const v = n.makeMarker();
        n.moveRangeBefore(v, v, g), c.sepStartRef = v, c.sepTracked = null, c.sepDisposeCallbacks = null;
        const O = {
          tracked: null,
          disposeCallbacks: null,
          track: ae,
          onDispose: ie
        };
        oe(O);
        let b;
        try {
          b = h(s(c.position)).render(
            g
          );
        } finally {
          ce();
        }
        c.sepTracked = O.tracked, c.sepDisposeCallbacks = O.disposeCallbacks, c.sepClear = b;
      }, Te = (c) => {
        c.sepClear && (u(
          c.sepTracked ?? null,
          c.sepDisposeCallbacks ?? null
        ), c.sepClear(!0), c.sepStartRef?.clear(!0), c.sepTracked = void 0, c.sepDisposeCallbacks = void 0, c.sepClear = void 0, c.sepStartRef = void 0);
      }, Ie = o.on(
        (c) => {
          if (c.length === 0 && l.length > 0) {
            B(), a.set(0);
            return;
          }
          const g = c.map(t), v = new Set(g);
          if (l.length > 0) {
            let f = !1;
            for (let k = 0; k < l.length; k++)
              if (v.has(l[k].key)) {
                f = !0;
                break;
              }
            if (!f) {
              const k = Math.min(l.length, c.length);
              p.clear();
              for (let y = 0; y < k; y++) {
                const D = l[y];
                D.key = g[y], D.valueProp.set(c[y]), D.position?.setIndex(y), p.set(g[y], D);
              }
              for (let y = l.length - 1; y >= k; y--)
                E(l[y]);
              if (l.length = k, c.length > k) {
                n.detach();
                for (let y = k; y < c.length; y++) {
                  const D = z(c[y], y, i);
                  p.set(g[y], D), l.push(D), s && y > 0 && !D.sepClear && j(D, D.startRef);
                }
                n.reattach();
              }
              a.set(c.length);
              return;
            }
          }
          const O = l.length === 0 && c.length > 0;
          O && n.detach();
          for (let f = l.length - 1; f >= 0; f--) {
            const k = l[f];
            v.has(k.key) || (E(k), p.delete(k.key), l.splice(f, 1));
          }
          const b = l.map((f) => f.key), x = [];
          for (let f = 0; f < c.length; f++) {
            const k = g[f];
            let y = p.get(k);
            y ? (y.valueProp.set(c[f]), y.position?.setIndex(f)) : (y = z(c[f], f, i), p.set(k, y)), x.push(y);
          }
          const G = /* @__PURE__ */ new Map();
          for (let f = 0; f < b.length; f++)
            G.set(b[f], f);
          const P = x.map(
            (f) => G.has(f.key) ? G.get(f.key) : -1
          ), I = [];
          for (let f = 0; f < P.length; f++)
            P[f] >= 0 && I.push({ newIdx: f, oldIdx: P[f] });
          const A = ge(I.map((f) => f.oldIdx)), Z = new Set(
            A.map((f) => I[f].newIdx)
          );
          for (let f = 0; f < x.length; f++)
            P[f] < 0;
          let F = i;
          for (let f = x.length - 1; f >= 0; f--) {
            const k = x[f];
            Z.has(f) || (k.sepStartRef && n.moveRangeBefore(
              k.sepStartRef,
              k.startRef,
              F
            ), n.moveRangeBefore(k.startRef, k.endRef, F)), F = k.sepStartRef ?? k.startRef;
          }
          if (s)
            for (let f = 0; f < x.length; f++) {
              const k = x[f];
              f === 0 ? Te(k) : k.sepClear || j(k, k.startRef);
            }
          l.length = 0, l.push(...x), a.set(c.length), O && n.reattach();
        },
        { noAutoDispose: !0 }
      );
      return (c) => {
        if (Ie(), c && l.length > 0)
          B();
        else {
          for (let g = 0; g < l.length; g++)
            E(l[g]);
          l.length = 0, p.clear();
        }
        a.dispose(), i.clear(c);
      };
    }),
    // Static array — just render once
    (o) => {
      const n = o;
      if (n.length === 0) return w;
      const i = q(n.length);
      return U(
        ...n.map((a, u) => {
          const l = q(a), p = new le(u, i);
          return s && u > 0 ? U(
            h(s(p)),
            h(r(l, p))
          ) : h(r(l, p));
        })
      );
    }
  ), $ = (e, t) => {
    function r(o) {
      return R((n) => {
        const i = n.makeMarker();
        let a, u;
        const l = o.map((d) => Object.keys(d)[0]);
        let p, C = null;
        const S = l.on((d) => {
          if (d !== p) {
            p = d, C?.dispose(), u?.dispose(), a?.(!0), C = new L(), u = o.map((M) => M[d]);
            const m = N(C, () => t[d](u));
            a = N(
              C,
              () => h(m).render(i)
            );
          }
        });
        return (d) => {
          C?.dispose(), u?.dispose(), S(), i.clear(d), a?.(d);
        };
      });
    }
    function s(o) {
      const n = Object.keys(o)[0];
      return h(t[n](q(o[n])));
    }
    return W(e, r, s);
  }, X = (e, t, r) => $(
    _.map(e, (s) => ({ [s[t]]: s })),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    r
  ), me = (e, t) => X(e, "kind", t), Ce = (e, t) => X(e, "type", t), Se = (e, t) => {
    const r = _.map(e, ([s, o]) => ({
      [s]: o
    }));
    return $(r, t);
  }, re = (e, t) => $(
    _.map(e, (r) => ({ [r]: !0 })),
    t
  ), ye = (e, t) => {
    if (H.is(e)) {
      const r = e;
      return R((s) => {
        const o = s.makeMarker(), n = r.map((u) => h(t(u)));
        let i = () => {
        };
        const a = n.on((u) => {
          i(!0), i = u.render(o);
        });
        return (u) => {
          a(), i(u);
        };
      });
    }
    return h(t(e));
  }, ve = (e, t, r) => {
    function s(n) {
      return R((i) => {
        const a = i.makeMarker();
        let u = () => {
        }, l = !1, p = null;
        const C = n.on((S) => {
          S == null ? (u(!0), u = h(r?.()).render(a), l = !1, p?.dispose(), p = null) : l ? p.set(S) : (p = K(S), u(!0), u = h(
            t(p)
          ).render(a), l = !0);
        });
        return (S) => {
          p?.dispose(), C(), u?.(S), a.clear(S);
        };
      });
    }
    function o(n) {
      if (n == null) {
        const i = r?.();
        return i != null ? h(i) : w;
      }
      return h(t(q(n)));
    }
    return W(
      e,
      s,
      o
    );
  }, Re = (...e) => (t, r) => R((s) => {
    const o = s.makeMarker();
    if (e.some(
      (d) => !H.is(d) && d == null
    ))
      return (r != null ? h(r?.()) : w).render(o);
    const i = e.map(
      () => null
    ), a = e.map(
      (d) => H.is(d) ? d.value != null : d != null
    );
    let u = null;
    const l = K(a.every((d) => d)), p = (d, m) => {
      if (d.value != null) {
        if (i[m] == null) {
          const M = K(d.value);
          i[m] = M;
        } else
          i[m].value = d.value;
        a[m] = !0;
      } else
        a[m] = !1;
    };
    let C = e.length - 1;
    const S = e.map((d, m) => {
      if (!H.is(d)) {
        const M = K(d);
        return i[m] = M, () => {
        };
      }
      return d.on(() => {
        p(d, m), C === 0 ? l.value = a.every((M) => M) : C--;
      });
    });
    return l.on((d) => {
      u?.(!0), u = null, d ? u = h(t(...i)).render(o) : u = h(r?.() ?? w).render(o);
    }), (d) => {
      i.forEach((m) => m?.dispose()), l.dispose(), S.forEach((m) => m()), u?.(d), o.clear(d);
    };
  }), Ee = (e, t, r = () => w) => $(
    _.map(
      e,
      (s) => s.length > 0 ? { notEmpty: s } : { whenEmpty: null }
    ),
    {
      notEmpty: (s) => t(s),
      whenEmpty: () => r()
    }
  ), Y = (e, t) => {
    if (typeof t == "function")
      return Y(e, { then: t });
    const r = t.pending != null ? h(t.pending()) : w, s = t.then, o = t.error != null ? (n) => h(t.error(n)) : () => w;
    return R((n) => {
      let i = !0;
      const a = e(), u = n.makeMarker();
      let l = h(r).render(u);
      return a.then(
        (p) => {
          i && (l(!0), l = h(s(p)).render(u));
        },
        (p) => {
          i && (l(!0), l = h(o(p)).render(u));
        }
      ), (p) => {
        i = !1, l(p), u.clear(p);
      };
    });
  }, xe = (e, t) => Y(() => e, t), se = (...e) => R(
    (t) => (r) => e.forEach((s) => {
      typeof s == "function" ? s(r, t) : s.dispose(r, t);
    })
  ), we = (e, t = {}) => (r) => {
    const s = t?.firstSeparator ?? e, o = t?.lastSeparator ?? e;
    return re(
      r.map((n) => n.isFirst ? "first" : n.isLast.value ? "last" : "other"),
      {
        first: s,
        last: o,
        other: e
      }
    );
  }, Oe = (e) => R((t) => {
    const r = new L(), s = N(
      r,
      () => h(e(r)).render(t)
    );
    return (o) => {
      r.dispose(), s(o);
    };
  }), V = (e) => R((t) => {
    let r = t;
    function s() {
      return r;
    }
    function o(a) {
      r = a;
    }
    const n = [], i = e({
      use: ({ mark: a }) => {
        const { value: u, onUse: l } = s().getProvider(a);
        return l?.(), u;
      },
      tryUse: ({ mark: a }) => {
        const u = s().tryGetProvider(a);
        if (u !== void 0)
          return u.onUse?.(), u.value;
      },
      set: ({ mark: a, create: u }, l) => {
        const { value: p, dispose: C, onUse: S } = u(l, s());
        n.push(C), o(s().setProvider(a, p, S));
      }
    });
    return i == null ? () => {
    } : U(
      h(i),
      se(() => n.forEach((a) => a()))
    ).render(s());
  }), be = (e, t, r) => V(({ set: s }) => (s(e, t), r())), Me = (e, t) => V(({ use: r }) => t(r(e))), Pe = (...e) => (t) => V(({ use: r }) => {
    const s = e.map(r);
    return t(...s);
  });
  function De(e, t, r) {
    if (r !== void 0) {
      const o = t;
      return V(({ tryUse: n }) => r(n(e) ?? o));
    }
    const s = t;
    return V(({ tryUse: o }) => s(o(e)));
  }
  return {
    Empty: w,
    Fragment: U,
    When: J,
    Unless: de,
    ForEach: he,
    KeyedForEach: ke,
    Repeat: Q,
    OneOf: $,
    OneOfField: X,
    OneOfKind: me,
    OneOfType: Ce,
    OneOfValue: re,
    OneOfTuple: Se,
    MapSignal: ye,
    Ensure: ve,
    EnsureAll: Re,
    NotEmpty: Ee,
    Task: Y,
    Async: xe,
    OnDispose: se,
    Conjunction: we,
    WithScope: Oe,
    Catch: (e, t) => {
      const r = h(e);
      return R((s) => {
        const o = s.makeMarker();
        let n = () => {
        }, i = null, a = null;
        const u = () => {
          i?.dispose(), n(!0), i = new L();
          try {
            n = N(
              i,
              () => r.render(o)
            );
          } catch (l) {
            i.dispose(), n(!0);
            const p = l instanceof Error ? l : new Error(String(l));
            i = new L(), a == null ? a = K(p) : a.set(p);
            const C = h(
              t(a, u)
            );
            n = N(
              i,
              () => C.render(o)
            );
          }
        };
        return u(), (l) => {
          i?.dispose(), n(l), a?.dispose(), o.clear(l);
        };
      });
    },
    WithProvider: V,
    Provide: be,
    Use: Me,
    UseMany: Pe,
    UseOptional: De,
    MapText: pe,
    handleValueOrSignal: W,
    createReactiveRenderable: ne,
    renderableOfTNode: h
  };
}
export {
  He as ProviderNotFoundError,
  Ne as createRenderKit
};
